import { useTranslate } from "@similarweb/i18n-provider";
import { ShoppingAds } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton, PromoBanner } from "@similarweb/ui-components";

import { useUpgradeBannerSubmit } from "../../hooks/useUpgradeBannerSubmit";
import SuccessBannerRow from "../SuccessBanner/SuccessBannerRow";

import { StyledRowPromoBanner } from "./styles";
import type { IFeatureUpgradeBannerProps } from "./types";

const FeatureUpgradeBannerRow = ({
    subtitleKey,
    buttonTextKey,
    titleKey,
    isSubmitted = false,
    withSuccessView = true,
    onSubmit,
}: IFeatureUpgradeBannerProps) => {
    const { translate } = useTranslate();

    const { isSuccessViewVisible, onButtonClick } = useUpgradeBannerSubmit({
        isSubmitted,
        withSuccessView,
        onSubmit,
    });

    if (isSuccessViewVisible) {
        return (
            <SuccessBannerRow
                title={translate("hook_modal.get_feature.success.title")}
                subTitle={translate("si.modal.get_feature.success.subtitle.v-2")}
            />
        );
    }

    return (
        <StyledRowPromoBanner data-automation="feature-upgrade-banner-row">
            <ShoppingAds
                size={24}
                color={colorsPalettes.indigo["300"]}
            />

            <PromoBanner.Content>
                {titleKey ? <PromoBanner.Title>{translate(titleKey)}</PromoBanner.Title> : null}

                <PromoBanner.Description>{translate(subtitleKey)}</PromoBanner.Description>
            </PromoBanner.Content>

            <IconButton
                data-automation="feature-upgrade-banner-row-cta"
                type="trial"
                iconName="sparkles"
                onClick={onButtonClick}
            >
                {translate(buttonTextKey)}
            </IconButton>
        </StyledRowPromoBanner>
    );
};

export default FeatureUpgradeBannerRow;
